export default ({ toggled, caption }, { rhythm, colors, radiuses, scale, transitions }) => ({
  root: {
    display: 'flex',
    fontSize: scale(-1),
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: rhythm(1),
    background: colors.light,
    color: colors.dark,
    border: `thin solid ${colors.shade}`,
    borderRadius: rhythm(radiuses.medium),
    marginBottom: rhythm(0.5),
    textAlign: 'left'
  },
  icon: {
    position: 'relative',
    width: rhythm(1.25),
    height: rhythm(1.25),
    flex: `0 0 ${rhythm(1.25)}`,
    backgroundColor: colors.shade,
    borderRadius: '50%',
    color: colors.light,
    marginRight: rhythm(0.75),
    svg: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    }
  },
  content: {
    flex: 1,
    marginTop: '0.333rem'
  },
  details: {
    fontSize: scale(-0.5),
    fontWeight: 'normal'
  },
  caption: {
    position: 'relative',
    marginTop: '0.5em',
    overflow: 'hidden',
    maxHeight: toggled ? '100vh' : '4.5em',
    transition: transitions.easeOut,
    cursor: (caption && caption.length > 75 && !toggled) ? 'pointer' : 'default',
    lineHeight: '1.5em',
    '&:before': {
      content: '""',
      opacity: toggled ? 0 : 1,
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      pointerEvents: 'none',
      background: `linear-gradient(transparent 1.5em, ${colors.light})`
    }
  },
  date: {
    fontWeight: 'bold',
    color: colors.primary,
    marginTop: '0.375rem',
    marginLeft: rhythm(0.75),
    fontSize: scale(-1.5),
    textAlign: 'right'
  }
})
